// BMI scale bar with a diamond marker at the user's current BMI.
export default function BmiScale({ bmi }) {
  const min = 15, max = 40;
  const pct = bmi ? Math.max(0, Math.min(100, ((bmi - min) / (max - min)) * 100)) : 0;
  return (
    <div className="mt-3">
      <div className="relative h-2 rounded-full overflow-hidden bg-neutral-100" dir="ltr">
        <div className="absolute inset-y-0 left-0 bg-sky-400" style={{ width: `${((18.5-15)/(max-min))*100}%` }} />
        <div className="absolute inset-y-0 bg-emerald-400" style={{ left: `${((18.5-15)/(max-min))*100}%`, width: `${((25-18.5)/(max-min))*100}%` }} />
        <div className="absolute inset-y-0 bg-amber-400" style={{ left: `${((25-15)/(max-min))*100}%`, width: `${((30-25)/(max-min))*100}%` }} />
        <div className="absolute inset-y-0 bg-red-500" style={{ left: `${((30-15)/(max-min))*100}%`, right: 0 }} />
        {bmi && (
          <div className="absolute -top-1.5 w-3 h-6 -ml-1.5" style={{ left: `${pct}%` }}>
            <div className="w-3 h-3 rotate-45 bg-neutral-900 -mb-1.5 mx-auto" />
            <div className="w-0.5 h-4 bg-neutral-900 mx-auto" />
          </div>
        )}
      </div>
      <div className="flex justify-between text-[10px] text-neutral-400 mt-1 num" dir="ltr">
        <span>15</span><span>18.5</span><span>25</span><span>30</span><span>40+</span>
      </div>
    </div>
  );
}
